<template>
  <!-- <div class="webview flex-row align-items-center"> -->
  <div class="app flex-row align-items-center">
    <div v-if="isLicenseAgreement">
      <web-view-license-agreement-zh/>
    </div>
    <div class="container" v-else>
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1>1on1navi服務使用規約</h1>
            <p>本使用規約（以下稱為「本規約」），係規定全體用戶於使用由Agile HR株式會社（以下稱為「本公司」）提供的本服務（第2條中定義）時所應遵守的事項，以及本公司和用戶之間的權利義務關係。請使用本服務的人務必在同意本規約前閱讀全文。</p>

            <h2>第1條<span>適 用</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本規約旨在明定用戶（其定義詳見第2條規定）在使用本服務（其定義詳見第2條規定）時與本公司之間的權利義務關係；本規約適用於用戶與本公司之間所有與使用本服務相關的關係。</li>
            <li><span class="nth">2.</span>本公司隨時於本網站（其定義詳見第2條規定）公布的本服務相關規則、各項規定等規範（其定義詳見第2條規定），將成為本規約的一部分。</li>
            </ul>
            <h2>第2條<span>定 義</span></h2>
            <ul class="list-unstyled">
            <li>下列使用於本規約用語，分別具有以下規定的含義：</li>
            <li>
              <ul class="list-unstyled">
            <li><span class="nth">(1)</span>「本服務」是指由本公司提供且名為「1on1navi」的服務（不問理由為何，於服務名稱或內容已有變更時，即包含該變更後的服務。）。本服務包括本條所定義的「本網站」以及「本應用程式（app）」。</li>
            <li><span class="nth">(2)</span>「本網站」是指網域名稱為「1on1navi.com」且由本公司營運的的網站（不問理由為何，於本公司網站的網域名稱或內容已變更時，即包含該變更後的網站。）。</li>
            <li><span class="nth">(3)</span>「本應用程式（app）」是指用於提供本服務的應用程式及相關軟體。</li>
            <li><span class="nth">(4)</span>「簽約人」是指第4條定義的「簽約人」。</li>
            <li><span class="nth">(5)</span>「擬註冊人」是指第4條定義的「擬註冊人」。</li>
            <li><span class="nth">(6)</span>「註冊資料」是指第4條定義的「註冊資料」。</li>
            <li><span class="nth">(7)</span>「用戶」是指獲簽約人准許使用本服務，同時根據第4條規定註冊為本服務用戶的個人。</li>
            <li><span class="nth">(8)</span>「ID」是指每位用戶為使用本服務而使用的特定字串（一般是指用戶於簽約人內部使用的電子郵件位址）。</li>
            <li><span class="nth">(9)</span>「密碼」是指與由用戶設定用於對應ID的特定字串。</li>
            <li><span class="nth">(10)</span>「智慧財產權」是指著作權、特許權（相當於台灣專利法規定的發明專利）、實用新案權（相當於台灣專利法規定的新型專利）、商標權，意匠權（相當於台灣專利法規定的設計專利）及其他智慧財產權（含申請取得前揭權利或註冊前揭權利等行為的權利。）。</li>
            </ul></li>
            </ul>
            <h2>第3條<span>使用本服務</span></h2>
            <ul class="list-unstyled">
            <li>用戶得於依第4條第4項規定成立據以使用本服務的契約有效期間內，遵照本公司規定方式使用本服務。</li>
            </ul>
            <h2>第4條<span>註 冊</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本僅限與本公司簽訂「1on1navi服務提供協議」的簽約人（以下稱為「簽約人」。）的高級主管以及員工當中，獲簽約人准許使用本服務的人員始可註冊。擬使用本服務的人員（以下稱為「擬註冊人」。），須同意遵守本規約，並用本公司規定的方式提供本公司指定的一定資料予本公司，據此向本公司申請註冊使用本服務。</li>
            <li><span class="nth">2.</span>用戶於註冊時須從簽約人所許可的資訊終端設備經由簽約人公司內部網站（須取得SSL憑證）列出的網址存取本網站，或從前揭資訊終端設備經由GooglePlay等服務商店下載安裝本應用程式。</li>
            <li><span class="nth">3.</span>申請註冊應由使用本服務的個人為之。原則上不承認由代理人註冊申請。另外，擬註冊人於申請註冊時，應提供真實、正確且最新的資料予本公司。</li>
            <li><span class="nth">4.</span>依據本條完成註冊後，即視同用戶與本公司之間已成立遵循本規約各項規定且與使用本服務相關的契約。</li>
            <li><span class="nth">5.</span>如果用戶的註冊資料已有變更，用戶須儘速按本公司規定的方法將前揭變更事項告知本公司，或經由簽約人通知本公司，再提供本公司所要求的資料。</li>
            </ul>
            <h2>第5條<span>本服務使用時間及客服機制</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本公司須付出符合經濟效益的合理努力，俾以提供本規約末尾記載的「本服務使用時間及客服機制等事項」記載的使用時間以及客服機制。另外，「本服務使用時間以及客服機制等事項」記載的服務，不適用於本規約所排除的服務，以及因免責事項引發的事項。</li>
            <li><span class="nth">2.</span>「本服務使用時間及客服機制等事項」係規定本公司就本服務所要努力的目標，縱本公司無法提供「本服務使用時間及客服機制等事項」記載的服務，本公司亦不承擔任何損害賠償及其他責任。</li>
            </ul>
            <h2>第6條<span>帳號資訊管理</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>用戶應自行負責管理和保管與本服務有關的ID和密碼（以下稱為「帳號資訊」。），不得供第三人使用，亦不得有出借、轉讓、變更名義、買賣等行為。</li>
            <li><span class="nth">2.</span>本公司得將利用帳號資訊使用本服務的狀況，視為係由已註冊使用的使用者本人使用本服務；，前揭使用行為產生的結果及其伴隨而生的一切責任均歸屬該用戶負擔。</li>
            <li><span class="nth">3.</span>因帳號資訊管理不善、使用錯誤、第三人使用或帳戶資訊不正確或不實等事由產生的損害責任，須由用戶自行負擔，本公司概不負責。</li>
            <li><span class="nth">4.</span>如因用戶非法使用其帳號資訊致本公司或者第三人受有損害，用戶須賠償本公司以及第三人前揭損害。</li>
            <li><span class="nth">5.</span>如用戶查明其帳號資訊遭竊取或遭第三人使用，須立即通知本公司同時遵照本公司的指示處理。</li>
            </ul>
            <h2>第7條<span>禁止行為</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>用戶使用本服務時不得有以下各款行為之一：</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>侵害本公司、簽約人、其他用戶或其他第三人的智慧財產權、肖像權、隱私權、名譽、其他權利或利益的行為（包括直接或間接引發侵權的行為。）</li>
            <li><span class="nth">(2)</span>恐嚇行為、與其他犯罪行為有關的行為，或違反公序良俗的行為</li>
            <li><span class="nth">(3)</span>違反法令或本公司、簽約人或用戶所屬職業團體內部規定的行為</li>
            <li><span class="nth">(4)</span>發送內含電腦病毒或其他有害的電腦程式的行為</li>
            <li><span class="nth">(5)</span>篡改涉及本服務且可資使用的資訊的行為</li>
            <li><span class="nth">(6)</span>透過本服務傳送容量在本公司規定的一定檔案量以上的檔案及其他造成本服務基礎設備承受過重負擔的行為</li>
            <li><span class="nth">(7)</span>攻擊本網站的伺服器、系統及安全防護措施的行為</li>
            <li><span class="nth">(8)</span>試圖用本公司提供的介面以外的方法存取本服務的行為</li>
            <li><span class="nth">(9)</span>單一用戶獲取多個帳號資訊的行為</li>
            <li><span class="nth">(10)</span>恐有妨礙本公司經營本服務之虞的行為</li>
            <li><span class="nth">(11)</span>其他經本公司判斷為不當的行為</li>
            </ul></li>
            <li><span class="nth">2.</span>若本公司判斷用戶透過本服務傳送資訊的行為符合前項各款行為之一，，或有符合前項任一款行為之虞時，本公司得不事先通知用戶而逕予刪除前揭資訊的全部或一部。本公司對依據本項規定採取的措施造成用戶所受的損害，概不負責。</li>
            </ul>
            <h2>第8條 <span>停止本服務等處理</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>如有下列情形之一，本公司得不事先通知用戶而逕予停止或暫停提供本服務的一部或全部：</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>檢查與本服務相關的電腦與系統或進行緊急維護作業</li>
            <li><span class="nth">(2)</span>電腦、通訊線路等設備因事故而停止</li>
            <li><span class="nth">(3)</span>因火災、停電、天災等不可抗力而導致本服務無法運作</li>
            <li><span class="nth">(4)</span>其他經本公司判斷有必要停止或暫停提供本服務的情形</li>
            </ul></li>
            <li><span class="nth">2.</span>本公司得依自身事由而終止提供本服務。發生前揭情形時，本公司須提前通知用戶。</li>
            <li><span class="nth">3.</span>本公司對依據本條規定所採取的措施對用戶造成的損害，概不負責。</li>
            </ul>
            <h2>第9條<span>設備負擔等事項</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>用戶須自行負責並負擔費用備置及維護供使用本公司提供的本服務所需的電腦、軟體與其他設備、通訊線路及其他通訊環境等設備。</li>
            <li><span class="nth">2.</span>用戶須自行負責並負擔費用採行符合自身使用本服務的環境，用於防止感染電腦病毒、非法接取行為以及資訊外洩等安全因應措施。</li>
            <li><span class="nth">3.</span>即使本公司因營運所需而在一定期間保存用戶傳送接收的訊息及其他資訊，本公司仍不負擔保存相關資訊的義務，本公司得隨時刪除前揭資訊。另外，本公司對於使用者因本公司刪除前揭資訊所產生的損害，概不負責。</li>
            <li><span class="nth">4.</span>用戶在開始使用本服務時或者正在使用本服務時，透過下載或其他方法將軟體等安裝於使用者的電腦等設備中，須充分注意勿使其持有的資訊滅失或改變，亦須避免引發設備故障、毀損等狀況；即便用戶因相關安裝行為而受有損害，本公司對此概不負責。</li>
            </ul>
            <h2>第10條<span>權利歸屬</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>與本服務相關的所有權以及智慧財產權全部歸屬於本公司或授權本公司之人所有。除本規約已有明示規定外，依本規約規定註冊而獲准使用本服務，不代表其受讓歸屬於本公司或授權本公司之人的智慧財產權或使用授權。用戶不論任何理由均不得採取恐有侵害本公司或授權本公司之人的智慧財產權的行為（包括但不以反組譯、反編譯、逆向工程為限。）。</li>
            <li><span class="nth">2.</span>用戶不得變更本公司或授權本公司之人對其智慧財產權的權利標示及說明。</li>
            <li><span class="nth">3.</span>用戶使用本服務所張貼及其他已傳送的文章的智慧財產權，須歸屬於該用戶。</li>
            </ul>
            <h2>第11条<span>閱讀資訊</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>如本公司判斷需確認有無違反與使用本服務相關的契約或有其他必要時，本公司有權閱讀用戶使用本服務而張貼及其他已傳送的文章及檔案等內容。</li>
            <li><span class="nth">2.</span>本公司為製作與本服務相關的統計數據，本公司有權閱讀用戶於使用本服務所張貼及其他已傳送的文章及資料等內容，用戶須予同意。</li>
            </ul>
            <h2>第12條<span>撤銷註冊等事項</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>如果用戶有下列各款事由之一，本公司得不事先通知或催告而逕予暫停該用戶使用本服務，亦得撤銷該用戶身分註冊：</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>違反本規約任一條款</li>
            <li><span class="nth">(2)</span>已查明其註冊資料與事實不符</li>
            <li><span class="nth">(3)</span>基於或憑藉恐導致本公司、其他用戶或其他第三人受有損害的目的或方法使用本服務，或擬據此使用本服務</li>
            <li><span class="nth">(4)</span>不問使用何種手段，凡已妨害本服務營運</li>
            <li><span class="nth">(5)</span>本公司與簽約人之間使用本服務的契約已終止或因其他原因而失效</li>
            <li><span class="nth">(6)</span>其他經本公司判斷不宜再以用戶身分繼續註冊</li>
            </ul></li>
            <li><span class="nth">2.</span>用戶如有上述各款事由之一，即當然喪失對本公司所負擔的一切債務可享有的期限利益，其應即刻向本公司支付全部債務。</li>
            <li><span class="nth">3.</span>本公司對於依據本條規定採取的行為致簽約人及用戶所受的損害，概不負責。</li>
            <li><span class="nth">4.</span>用戶經本公司依本條規定撤銷註冊後，用戶須遵照本公司的指示返還、銷毀及其他處分方式處理由本公司所提供與本服務相關的軟體和其他物品。</li>
            </ul>
            <h2>第13條<span>不予保證及免責</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本公司對本服務的內容變更、中斷、終止而衍生的任何損害，概不負責。</li>
            <li><span class="nth">2.</span>本公司一概不介入用戶使用本服務的環境，亦不為此負擔任何責任。</li>
            <li><span class="nth">3.</span>本公司概不予保證本服務符合用戶的特定目的、具備其所期待的功能、產品價值、準確性與實用性、用戶使用本服務的行為符合適用於用戶的法令或或職業團體的內部規則等規範，亦不保證本服務不故障。</li>
            <li><span class="nth">4.</span>本公司不予保證本服務與所有資訊終端設備相容；本服務的運作可能受到用於使用本服務的資訊終端設備的OS版本升級等因素影響而出現故障，敬請用戶瞭解配合。本公司不予保證本公司於發生故障時，該故障可因採行的修正程式等措施而解除。</li>
            <li><span class="nth">5.</span>使用本服務一部或全部的行為，可能因GooglePlay等服務商店的契約及運作方針的變更而受到限制，敬請用戶瞭解配合。</li>
            <li><span class="nth">6.</span>本公司對於使用因使用本服務而直接或間接產生的損害，概不負責。</li>
            <li><span class="nth">7.</span>本公司對於用戶或其他第三人遭遇的機會損失、業務中斷及其他任何損害（含間接損害和所失利益），即使本公司已事先接獲告知衍生損害的可能性，仍不負擔任何責任。</li>
            <li><span class="nth">8.</span>第1項至第7項的規定不適用於本公司有故意或重大過失的情況。</li>
            <li><span class="nth">9.</span>縱適用前項規定，本公司對於用戶所受的損害中因特殊事由造成的損害，仍不負擔任何賠償責任。</li>
            <li><span class="nth">10.</span>如本公司就有關本服務的使用行為負擔賠償責任時，本公司對用戶、簽約人及其他第三人負擔的損害賠償責任合計金額，係以本公司於前揭損害發生當月收受簽約人繳納的使用費為上限。</li>
            <li><span class="nth">11.</span>即使用戶直接或間接經由本公司獲得與本服務、本服務的其他用戶以及其他事項相關的任何資訊，本公司對用戶不提供逾越本規約規定內容的任何保證。</li>
            <li><span class="nth">12.</span>用戶須自行負責並負擔費用調查使用本服務是否違反適用於用戶的法令、職業團體的內部規則等規範；本公司對於用戶使用本服務的行為是否符合適用於用戶的法令、職業團體的內部規則等規範，概不予保證。</li>
            <li><span class="nth">13.</span>本公司對於因本公司中斷提供、停止、終止本服務、本服務無法使用或變更、用戶留言或資訊刪除或消失、用戶註冊遭撤銷、使用本服務導致檔案滅失或設備故障或毀損及其他與本服務有關導致用戶所受損害，概不負任何賠償責任。</li>
            <li><span class="nth">14.</span>本服務縱有提供從本網站到接取其他網站的連結或從其他網站接取本網站的連結，本公司不問任何理由對於本網站以外的網站及從該網站獲取的資訊，概不負責。</li>
            <li><span class="nth">15.</span>用戶須預先同意本公司得將本服務相關作業的全部或一部再重新委託第三人。</li>
            </ul>
            <h2>第14條<span>用戶賠償責任等事項</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>用戶須賠償本公司因其違反本規約，或與其使用本服務相關致本公司所受的損害（含訴訟費用及律師費用）。</li>
            <li><span class="nth">2.</span>用戶如接獲由其他用戶或其他第三人提出與本服務有關的投訴，或用戶與上述人等發生糾紛，用戶須立即將此內容通知本公司，同時須自行負擔費用並負責處理前揭投訴或糾紛，再照本公司的要求向本公司報告處理經過和結果。另外，用戶如與第三人發生糾紛亦同樣須將此內容通知本公司，同時自行負擔費用並負責處理糾紛，再照本公司的要求向本公司報告處理經過和結果。</li>
            <li><span class="nth">3.</span>本公司如因用戶使用本服務而接獲其他用戶或其他第三人以侵權或其他理由為由而提出的請求時，用戶須賠償所有本公司被迫依上述要求支付前揭第三人的金額（含律師費用和所失利益）。</li>
            </ul>
            <h2>第15條<span>保密義務</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本公司及用戶因使用本服務簽訂及履行契約隨之知悉他方當事人的業務面或技術面資訊，同時經他方事人指定或明示為秘密的資訊（以下稱為「秘密資訊」。），限供履行本契約之用，同時禁止將之向第三人揭示亦不得洩漏第三人。但事前經他方當事人書面同意的情形，不在此限。</li>
            <li><span class="nth">2.</span>下列各款資訊均不屬秘密資訊，不受前項規定拘束：</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>於揭示時已屬公眾周知的資訊，或於揭示後非可歸責於接收人而已成為的公眾周知的資訊</li>
            <li><span class="nth">(2)</span>於揭示秘密資訊的當事人（以下稱為「揭示人」。）揭示時，已接收秘密資訊的當事人（以下稱為「接收人」。）既已持有的資訊</li>
            <li><span class="nth">(3)</span>接收人從正當途徑經由無須負擔保密義務的第三人取得的資訊</li>
            <li><span class="nth">(4)</span>於揭示人揭示後始開發而出的資訊，並可證明前揭資訊非依揭示人提供的資訊而開發</li>
            </ul></li>
            <li><span class="nth">3.</span>遭國家機關要求及依其他法令規定而負有義務揭示秘密資訊的義務時，接收人得揭示該資訊。但接收人須迅速將此事通知揭示人。</li>
            <li><span class="nth">4.</span>於本契約失效後或他方當事人提出要求的情況下，本公司及用戶須遵照他方的指示迅速返還或銷毀秘密資訊。</li>
            </ul>
            <h2>第16條<span>個人資料保護</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本規約所要規範的個人資料為個人資料保護法第2條規定的個人資料。</li>
            <li><span class="nth">2.</span>本公司須本於善良管理人的注意管理因本服務營運（以下稱為「本業務」。）而得知的本規約所要規範的個人資料，未經書面同意不得將之用於執行本業務及製作統計數據以外的目的，亦不得讓第三人使用或向第三人揭示、洩漏第三人。</li>
            <li><span class="nth">3.</span>本公司須採行防止個人資料洩漏、滅失、毀損以及妥適管理本規約所要規範的個人資料所需的必要措施。</li>
            <li><span class="nth">4.</span>本公司銷毀已複製完成的本規約規範的個人資料副本時，如前揭副本屬書面文件係採取裁切或燒毀的方法處理，如屬電磁紀錄則採取刪除檔案或破壞載具的方法處理。</li>
            </ul>
            <h2>第17條<span>排黑條款</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>用戶須聲明並保證其不符合下列任一款規定：</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>幫派、幫派成員、準幫派成員、幫派相關企業、職業股東、標榜從事社會運動與政治活動而勒索金錢之人、特殊智慧暴力集團等組織、其他反社會勢力或已不具幫派成員身分未逾5年者（以下併稱「幫派勢力」。）</li>
            <li><span class="nth">(2)</span>東京都排黑條例中規定的管制對象</li>
            </ul></li>
            <li><span class="nth">2.</span>本公司如查明用戶符合前項各款規定，或查明用戶符合下列各款之一者，本公司得不經任何催告而逕予暫停該用戶使用本服務，或撤銷該用戶的註冊：</li>
            <li><ul class="list-unstyled">
            <li><span class="nth">(1)</span>經認定由幫派勢力主導經營或實質介入經營</li>
            <li><span class="nth">(2)</span>經認定基於謀求本身或第三人的非法利益，或試圖加害第三人等目的而利用幫派勢力</li>
            <li><span class="nth">(3)</span>經認定涉及為幫派勢力提供金援等，或提供方便或利益輸送等行為</li>
            <li><span class="nth">(4)</span>本身或利用第三人實施暴力要求行為、逾越法律責任的不當要求行為、言行脅迫或使用暴力等行為</li>
            <li><span class="nth">(5)</span>其他類似上述各款的行為</li>
            </ul></li>
            <li><span class="nth">3.</span>如因本公司根據前項規定暫停用戶使用本服務或撤銷用戶註冊致該用戶受有損害，本公司亦不負擔任何損害賠償義務。</li>
            </ul>
            <h2>第18條<span>有效期間</span></h2>
            <ul class="list-unstyled">
            <li>於本公司與用戶之間成立的使用本服務相關契約，係自用戶依據第4條規定完成註冊之日起生效，其效力持續至該用戶遭撤銷註冊之日或本服務已終止提供之日兩者中先行屆至的日期為止。。</li>
            </ul>
            <h2>第19條<span>本契約等變更內容</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>本公司得任意變更本服務的內容。</li>
            <li><span class="nth">2.</span>本公司得在不變更本契約所定本服務內容的範圍內，任意變更「本服務的使用時間和客服機制等事項」。</li>
            <li><span class="nth">3.</span>本公司得變更本規約（含本公司網站公布的本服務相關規則、各項規定等規範。以下於本項規定亦同。）。本公司如已變更本規約，須通知用戶該變更內容；於前揭變更內容的通知後，用戶如繼續使用本服務或未於本公司規定的期間內辦理撤銷註冊的程序，即視同用戶同意本規約的變更。</li>
            </ul>
            <h2>第20條<span>聯絡/通知</span></h2>
            <ul class="list-unstyled">
            <li>本服務相關洽詢及其他用戶對本公司發送的聯絡或通知，以及與本規約變更相關通知及其他本公司對用戶發送聯絡或通知，須經由設置在本網站或本應用程式適當位置的洽詢表單傳送，或按照本公司另行規定的方法進行。</li>
            </ul>
            <h2>第21條<span>讓與本規約所定地位等事項</span></h2>
            <ul class="list-unstyled">
            <li><span class="nth">1.</span>未經本公司事前書面同意，用戶不得將本規約的地位及本規約所定權利和義務讓與、移轉第三人，亦不得以此為第三人設定擔保及為其他處分。</li>
            <li><span class="nth">2.</span>本公司如已將本服務相關業務讓與（究屬營業讓與、公司分割或任何其他態樣在所不問。）第三人，本公司得將本契約的地位、本規約規定的權利和義務以及用戶的註冊資料及其他客戶資訊讓與前揭轉讓行為的受讓人；用戶須預先同意本項規定的讓與。</li>
            </ul>
            <h2>第22條<span>最終條款</span></h2>
            <ul class="list-unstyled">
            <li>本規約構成本公司和用戶之間就本規約涵蓋事項的完整合意，同時優先於本公司與用戶以口頭或書面形式就本規約涵蓋事項達成的事前合意、聲明和理解。</li>
            </ul>
            <h2>第23條<span>規定的可分離性</span></h2>
            <ul class="list-unstyled">
            <li>本規約的任一條款或部分條款經依消費者契約法及其他法令等規範遭判定為無效或無法執行，本規約其餘規定及部分經判定為無效或無法執行規定的剩餘部分，仍持續具有完整效力，本公司及用戶須盡力於必要範圍修正前揭無效或無法執行的條款或其部分，使其適法並可資執行，同時保有與前揭無效或無法執行的條款或其部分同等的法律及經濟效果。</li>
            </ul>
            <h2>第24條<span>續存規定</span></h2>
            <ul class="list-unstyled">
            <li>第6條第3項與第4項規定、第7條第2項、第8條第3項、第9條、第10條、第11條、第12條第3項，第4項與第5項、第13條至第17條以及第21條至25條規定，於本規約失效後其效力仍存續。但第16條規定係於使用本服務的相關契約失效後3年內其效力仍存續。</li>
            </ul>
            <h2>第25條<span>準據法與管轄法院</span></h2>
            <ul class="list-unstyled">
            <li>本規約的準據法為日本法；因所有因本規約引起或與本規約有關的紛爭，均以東京地方法院或東京簡易法院為一審專屬管轄法院。</li>
            </ul>
            <h2>第26條<span>協商解決</span></h2>
            <ul class="list-unstyled">
            <li>本公司與用戶對本規約未規定事項或對本規約的解釋遇有疑義時，雙方須本著誠實信用原則經協商後迅速解決之。</li>
            </ul>

            <p class="text-right">【2017年11月30日訂定】</p>

            <h3 class="text-center">本服務使用時間及客服機制等事項</h3>
            <dl>
            <dt> (使用時間）</dt>
            <dd><ul class="list-unstyled">
            <li>除維護時間外，本服務的使用時間如下。</li>
            <li>24小時365天（閏年366天）</li>
            </ul></dd>
            <dt>（客服窗口）</dt>
            <dd><ul class="list-adjusted">
            <li>僅受理簽約人或用戶的洽詢。</li>
            <li>客服窗口服務時間</li>
            <li><ul class="list-unstyled">
            <li>經由電子郵件等形式受理：24小時365天（閏年366天）</li>
            <li>處理①：平日（※）的10:00-17:00</li>
            <li>（※）平日意指扣除週六、週日、國定假日及日本新年假期（12月29日至1月3日）之日</li>
            </ul></li>
            </ul></dd>
            <dt>（維護作業所需的計劃性停止等狀況）</dt>
            <dd><ul class="list-adjusted">
            <li>本公司為進行每月一次的維護作業，得計劃性停止6小時。計劃性停止須在平日18:00以後的夜間進行。</li>
            <li>因受雲端環境影響，為進行維護作業可能定期、不定期（數秒～數分鐘）無法接取。</li>
            </ul></dd>
            </dl>

            <p class="text-right">以上</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
/* .webview {
  overflow: auto;
} */
.app{
  display: block;
  overflow: visible;
  height: 100%;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
  margin: 2rem auto;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
span.nth {
  margin-right: 0.5em;
}
/* ul.list-adjusted {
  padding-left: 1.5em;
} */
ul.list-unstyled {
  margin-bottom: 2rem;
}
ul.list-unstyled li {
  margin: 0.8rem auto;
}
</style>

<script>
import WebViewLicenseAgreementZh from '@/views/_webview/WebViewLicenseAgreementZh'
import { licenseAgreement } from '@/main'

export default {
  name: 'WebViewTermsZH',
  components: {
    WebViewLicenseAgreementZh
  },
  computed: {
    isLicenseAgreement: function () {
      return licenseAgreement
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/views/_webview/WebViewTermsZH.vue